import { createAsyncThunk, createSlice, EntityState } from '@reduxjs/toolkit';
import { ExtensiveAttributeModel, NotDataAuthorizationQuery, ContentTagServiceAccessPermissionQuery } from 'types/entity';
import { fetchExtensiveAttributeDefinitions } from 'api/extensive-attribute-definition.service';
import { createExtensiveAttributeDefinitions } from 'redux/extensive-attribute-definition-create/extensive-attribute-definition-create.slice';
import { extensiveAttributeDefinitionReadAdapter } from './extensive-attribute-definition-read.adapter';

export const EXTENSIVE_ATTRIBUTE_DEFINITION_READ_STORE_NAME = 'extensiveAttributeDefinitionRead';

export const loadExtensiveAttributeDefinitions = createAsyncThunk(
  `${EXTENSIVE_ATTRIBUTE_DEFINITION_READ_STORE_NAME}/load`,
  async (payload: {selectedProjectId: string, notDataAuthorization: NotDataAuthorizationQuery, contentTagServiceAccessPermission: ContentTagServiceAccessPermissionQuery}) => {
    const { selectedProjectId, notDataAuthorization, contentTagServiceAccessPermission } = payload;
    return fetchExtensiveAttributeDefinitions(selectedProjectId, notDataAuthorization, contentTagServiceAccessPermission);
  },
);

export type ExtensiveAttributeDefinitionReadState = EntityState<ExtensiveAttributeModel> & {
  loaded: boolean
  error: any
}

export const initialExtensiveAttributeDefinitionReadState: ExtensiveAttributeDefinitionReadState = extensiveAttributeDefinitionReadAdapter.getInitialState({
  loaded: false,
  error: null,
});

export const extensiveAttributeDefinitionReadSlice = createSlice({
  name: EXTENSIVE_ATTRIBUTE_DEFINITION_READ_STORE_NAME,
  initialState: initialExtensiveAttributeDefinitionReadState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadExtensiveAttributeDefinitions.pending, (state) => {
      extensiveAttributeDefinitionReadAdapter.removeAll(state);
      state.loaded = false;
    });
    builder.addCase(loadExtensiveAttributeDefinitions.fulfilled, (state, action) => {
      const valuesSorted = action.payload.map((def) => ({
        ...def,
        extensive_attribute_value: def?.extensive_attribute_value?.sort((a, b) => (a.display_order || 0) - (b.display_order || 0)),
      }));
      extensiveAttributeDefinitionReadAdapter.addMany(state, valuesSorted);
      state.loaded = true;
    });
    builder.addCase(loadExtensiveAttributeDefinitions.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
    builder.addCase(createExtensiveAttributeDefinitions.fulfilled, (state, action) => {
      extensiveAttributeDefinitionReadAdapter.upsertOne(state, action.payload);
    });
  },
});

export const extensiveAttributeDefinitionReadActions = {
  ...extensiveAttributeDefinitionReadSlice.actions,
  loadExtensiveAttributeDefinitions,
};

export default extensiveAttributeDefinitionReadSlice.reducer;
